<template>
  <tr>
    <td class="">
      <router-link :to="{name:'single', params:{slug: link}}" v-on:click.native="goToDataView">
        <p>{{title}}</p>
      </router-link>
    </td>
    <td class="">
      <span class="amount">{{term}}</span>
    </td>
    <td class="">
      <p v-if="area">{{area}}</p>
    </td>
  </tr>
</template>
<script>
  import scrollTo from 'vue-scrollto';

  export default {
    name: 'filerow',
    props: ['title', 'link', 'term', 'modified', 'area'],
    methods: {
      goToDataView() {
        scrollTo.scrollTo('#view-data', 500);
      },
    },
    data() {
      return {};
    },
  };
</script>



// WEBPACK FOOTER //
// fileRow.vue?e3ddaf98